import p1 from './20160305-p1.pdf';
import p2 from './20160305-p2.pdf';
import p3 from './20160305-p3.pdf';
import p4 from './20160305-p4.pdf';

const problems = { p1, p2, p3, p4 };

export default problems;